/**
 * Gli errori di accessibilita' di un documento, chiusi sotto «N errori rilevati».
 *
 * Il conteggio e' l'unica riga sempre visibile: l'elenco aperto, con il
 * messaggio del controllo e un rimedio per riga, allungava il dettaglio di una
 * pubblicazione e il riquadro dopo un caricamento fino a nascondere il resto.
 * Chi vuole sapere che cosa manca apre il menu, e ci trova anche chi ha
 * giudicato e come si interviene. Un menu per documento, non per controllo:
 * a chi corregge interessa che cosa manca al file, non quale controllo l'ha
 * visto.
 *
 * Restano fuori dal menu solo cio' che blocca la pubblicazione, che non e' un
 * dettaglio da andare a cercare, e l'intervento di un controllo non riuscito,
 * che non ha errori da contare (`interventoSenzaErrori`).
 */

import type { Documento } from "../api/types";
import {
  COSA_FARE,
  etichettaControllo,
  fonteLeggibile,
  interventoSenzaErrori,
  mancanzeDi,
  statoDi,
  testoErroriRilevati,
} from "../lib/accessibilita";

function Intervento({ testo }: { testo: string }) {
  return (
    <p className="campo__aiuto">
      <strong>Intervento:</strong> {testo}
    </p>
  );
}

export function ErroriRilevati({ documento }: { documento: Documento }) {
  const mancanze = mancanzeDi(documento);
  const bloccanti = (documento.esiti_validazione?.controlli ?? []).filter(
    (controllo) => controllo.esito === "fallito" && controllo.bloccante,
  );
  const senzaErrori = interventoSenzaErrori(documento);
  const fonte = fonteLeggibile(documento);
  const intervento = COSA_FARE[statoDi(documento)];
  return (
    <>
      {bloccanti.map((controllo) => (
        <p key={controllo.nome} className="campo__errore">
          {etichettaControllo(controllo.nome)}: blocca la pubblicazione
        </p>
      ))}
      {senzaErrori ? <Intervento testo={senzaErrori} /> : null}
      {mancanze.length > 0 ? (
        // `<details>` e' nativo: si apre da tastiera e lo screen reader ne
        // annuncia lo stato.
        <details className="legenda-compatta">
          <summary>{testoErroriRilevati(mancanze.length)}</summary>
          <div className="pila-stretta">
            <ul className="pila-stretta">
              {mancanze.map((voce) => (
                <li key={voce}>· {voce}</li>
              ))}
            </ul>
            {fonte ? (
              <p className="campo__aiuto">Fonte del giudizio: {fonte.testo}</p>
            ) : null}
            {intervento ? <Intervento testo={intervento} /> : null}
          </div>
        </details>
      ) : null}
    </>
  );
}
